// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.topbar-logo[data-v-02d8e7eb] {
  display: block;
  height: 2rem;
  width: auto;
  max-height: 2rem;
  object-fit: contain;
}
.dashboard-layout[data-v-02d8e7eb] {
  width: 100%;
  margin: 0;
  padding: 0;
}
.dashboard-layout>.sidebar[data-v-02d8e7eb] {
  margin-left: 0;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.dashboard-layout>.sidebar>.d-flex.flex-column[data-v-02d8e7eb] {
  flex: 1 1 auto;
  min-height: 0;
}
.dashboard-layout>.sidebar>.sidebar-footer[data-v-02d8e7eb] {
  flex-shrink: 0;
  margin-top: auto;
}
.dashboard-layout>.container-fluid[data-v-02d8e7eb] {
  flex: 1 1 0%;
  min-width: 0;
}
.sidebar-backdrop[data-v-02d8e7eb] {
  position: fixed;
  inset: 0;
  z-index: 1035;
  background: rgba(0, 0, 0, 0.4);
}
.sidebar-close-mobile[data-v-02d8e7eb] {
  flex-shrink: 0;
  line-height: 1;
  text-decoration: none;
}
.sidebar-close-mobile[data-v-02d8e7eb]:hover,
.sidebar-close-mobile[data-v-02d8e7eb]:focus {
  color: #fff8ee;
  text-decoration: none;
}

/* Mobile: drawer overlays content instead of pushing the flex layout. */
@media (max-width: 767.98px) {
.dashboard-layout>.sidebar[data-v-02d8e7eb] {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1040;
}
.dashboard-layout>.container-fluid[data-v-02d8e7eb] {
    width: 100%;
    max-width: 100%;
}
}
.listaDashboard[data-v-02d8e7eb] {
  width: 100%;
  min-width: 0;
}
.listaDashboard .nav-item[data-v-02d8e7eb] {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border-radius: 0.375rem;
  transition: background-color 0.2s ease;
}
.listaDashboard .nav-item-current .nav-link[data-v-02d8e7eb] {
  background-color: rgba(0, 0, 0, 0.18);
  border-radius: 0.375rem;
}
.listaDashboard .nav-item-current .nav-link span[data-v-02d8e7eb],
.listaDashboard .nav-item-current .nav-link i[data-v-02d8e7eb] {
  color: #fff8ee !important;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Dashboard.vue"],"names":[],"mappings":";AAkaA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;AAC7B;AAEA;EACE,cAAc;EACd,aAAa;AACf;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AAEA;EACE,YAAY;EACZ,YAAY;AACd;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;AAChC;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;AACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;AACf;AAEA;IACE,WAAW;IACX,eAAe;AACjB;AACF;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;AACxC;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":["\n.topbar-logo {\n  display: block;\n  height: 2rem;\n  width: auto;\n  max-height: 2rem;\n  object-fit: contain;\n}\n\n.dashboard-layout {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.dashboard-layout>.sidebar {\n  margin-left: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  max-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n\n.dashboard-layout>.sidebar>.d-flex.flex-column {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.dashboard-layout>.sidebar>.sidebar-footer {\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n.dashboard-layout>.container-fluid {\n  flex: 1 1 0%;\n  min-width: 0;\n}\n\n.sidebar-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1035;\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.sidebar-close-mobile {\n  flex-shrink: 0;\n  line-height: 1;\n  text-decoration: none;\n}\n\n.sidebar-close-mobile:hover,\n.sidebar-close-mobile:focus {\n  color: #fff8ee;\n  text-decoration: none;\n}\n\n/* Mobile: drawer overlays content instead of pushing the flex layout. */\n@media (max-width: 767.98px) {\n  .dashboard-layout>.sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 1040;\n  }\n\n  .dashboard-layout>.container-fluid {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.listaDashboard {\n  width: 100%;\n  min-width: 0;\n}\n\n.listaDashboard .nav-item {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s ease;\n}\n\n.listaDashboard .nav-item-current .nav-link {\n  background-color: rgba(0, 0, 0, 0.18);\n  border-radius: 0.375rem;\n}\n\n.listaDashboard .nav-item-current .nav-link span,\n.listaDashboard .nav-item-current .nav-link i {\n  color: #fff8ee !important;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
